import { Link } from "gatsby";
import React, { useEffect } from "react";
import { Footer } from "./Footer";
import { Header } from "./Header";

const sideItem = [
	{ name: "Privacy Policy", path: "/privacy-policy" },
	{
		name: "Customer Personal Info Protection Policy",
		path: "/protection-policy",
	},
	{
		name: "Terms and Conditions",
		path: "/terms-and-conditions",
	},
];
export const LegalLayout = ({ children, location }) => {
	let AOS;
	useEffect(() => {
		const AOS = require("aos");
		AOS.init({
			once: true,
		});
	}, []);

	useEffect(() => {
		if (AOS) {
			AOS.refresh();
		}
	});
	if (typeof window !== "undefined") {
		// eslint-disable-next-line global-require
		require("smooth-scroll")('a[href*="#"]');
	}

	console.log({ location });
	return (
		<main className="bg-[#F9FAFC]">
			<Header location={location} />
			<div className="lg:flex justify-center space-y-5 lg:space-y-0 lg:space-x-4 px-5">
				{location.pathname !== "/privacy-policy" && (
					<div
						className={[
							"rounded-[10px]  overflow-hidden flex flex-col lg:max-w-[284px] bg-white self-start shadow-sm",
							location.pathname === "/protection-policy"
								? "lg:mt-[1.35rem]"
								: "lg:mt-[7.3rem]",
						].join(" ")}
					>
						{sideItem.map((item, index) => (
							<Link
								to={item.path}
								key={index}
								className={[
									"block w-full text-left text-sm px-6 py-4 whitespace-nowrap overflow-ellipsis overflow-hidden",
									"text-kBlack ",
								].join(" ")}
								activeClassName="text-kBlue bg-kBlue bg-opacity-10"
							>
								{item.name}
							</Link>
						))}
					</div>
				)}

				<div>{children}</div>
			</div>
			<Footer />
		</main>
	);
};
